//import Menu from "./Menu";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import Popover from '@material-ui/core/Popover';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';


import usePresentSelector from './usePresentSelector';
import GetAppIcon from '@material-ui/icons/GetApp';
import A from './ActionCreators';
import SvgGrid from './SvgGrid';
import { useDispatch, useStore } from 'react-redux';
import { useState, useRef } from 'react';

import getImageUrlMap from './getImageUrlMap';

import Spinner from 'react-bootstrap/Spinner'

import { ErrorBoundary } from 'react-error-boundary';

export default function ExportButton({setSvg,color, figurePanelId, button}){

  if( !figurePanelId ){
    throw Error("ExportButton must be passed 'figurePanelId'.");
  }


  let dispatch = useDispatch();

  const [downloadFmt,setDownloadFmt] = useState(null);

  const anchorEl = useRef(null);

  const [imageUrlMap, setImageUrlMap] = useState(null);
  const [showOpts, setShowOpts] = useState(false);

  if( imageUrlMap ){
  }

  const notifyFinishedDownload = () => {
    setImageUrlMap(null);
    setDownloadFmt(false);
  }

  const store = useStore();


  let menuButtonStyle = { fontSize:12,
    background:color,
    color:(color?'white':'unset'),
    display:'flex',
    alignItems:'center',
    fontWeight:500,
  }


  function showSaveFilePicker() {
    setShowOpts(true);
  }

  function startDownload(fmt) {
    if (downloadFmt) {
      // Don't allow multiple downloads at once
      return;
    }
    try{
      setDownloadFmt(fmt);
      getImageUrlMap(store.getState(),{figurePanelId}).then(setImageUrlMap);
      dispatch(A.exportFigure({format:fmt,figurePanelId}))
    }catch(error){
      setDownloadFmt(null);
      dispatch(A.exportFigureFailed({
        message:JSON.stringify([
          error.message, error.stack
        ])
      }))
    }
  }


  return (
    <div class="sg-row export-button">

      <div 
        style={menuButtonStyle} 
        class={"small-padding-left small-padding-right hoverable-green round-corners-left tiny-margin-left"}
        button={button}
        onClick={() => startDownload('svg')}>
        {downloadFmt && imageUrlMap && (
          <div style={{display:'block'}}>
            <ErrorBoundary onError={(error,info)=>{
              setDownloadFmt(null);
              dispatch(A.exportFigureFailed({
                message:JSON.stringify([ error, info ])
              }))


            }}
              FallbackComponent={() => <div/>}
              fallbackRender={({error,resetErrorBoundary,componentStack}) => {

                debugger;
                return (
                  <div/>
                )
              }}>

              {downloadFmt && <SvgGrid 
                figurePanelId={figurePanelId}
                download={true}
                format={downloadFmt}
                setSvg={setSvg}
                state={store.getState()}
                imageUrlMap={imageUrlMap}
                notifyFinishedDownload={notifyFinishedDownload}
                //notifyFinishedDownload={() => {}}
              />}
            </ErrorBoundary>
          </div>
        )}

        {!downloadFmt && (
          <div class="sg-col v-center">
            <GetAppIcon style={{padding:0}}/>

            {false && <div style={{
              fontSize:10
            }}>Export</div>}

            
          </div>
        )}
        {downloadFmt && (
          <Spinner
            style={{height:20,width:20}}
            animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        )}
      </div>
      <div 
        onClick={() => {
          // window.showSaveFilePicker?.();
          showSaveFilePicker();
        }}
        onMouseLeave={() => setShowOpts(false)}
        style={{
        borderLeft:'1px solid #aca',
      }} class="sg-row v-center round-corners-right hoverable-green rel" ref={anchorEl}>
        <ArrowDropDownIcon/>

        <Popover
          anchorEl={anchorEl.current}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
          keepMounted
          open={showOpts}
          onMouseLeave={() => setShowOpts(false)}
        >
          <MenuList onMouseLeave={() => setShowOpts(false)}>
            <MenuItem onClick={() => startDownload('svg')}>
              To SVG
            </MenuItem>
            <MenuItem onClick={() => startDownload('png')}>
              To PNG
            </MenuItem>
          </MenuList>
        </Popover>
      </div>
    </div>
  )

}
